import React from "react";
import { OpenInNew } from "@mui/icons-material";
import { Button } from "@mui/material";
import type { ServerLicenseDto } from "client/api-v2";

interface ServerSubscriptionActionsProps {
  license: ServerLicenseDto | null;
  loading: boolean;
}

export function ServerSubscriptionActions({ license, loading }: ServerSubscriptionActionsProps) {
  const telemetryUrl = license?.serial
    ? `https://app.snowflake.com/rh51976/pv38481/#/streamlit-apps/PROD_MODEL.COMMERCIAL.%22Account%20Usage%20Dashboard%22/!/license?streamlit-license_id=${license.serial}`
    : "";

  return (
    <Button
      variant="contained"
      component="a"
      target="_blank"
      href={telemetryUrl || undefined}
      disabled={loading || !telemetryUrl}
      rel="noopener noreferrer"
    >
      Telemetry <OpenInNew fontSize="small" sx={{ paddingLeft: 1 }} />
    </Button>
  );
}
